import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { SupportEmail } from "./Access";
import { AppBadges } from "./AppBadges";

const L = "inline-flex min-h-control items-center text-[15px] text-neutral-ink underline-offset-4 transition-colors hover:text-clay-strong hover:underline";
const HEAD = "flex h-8 items-end text-xs font-semibold uppercase tracking-[0.16em] text-clay-strong";
const LEARN = [["/about/learning", "footer-page-learning", "b5.nav.learning"], ["/about/methodology", "footer-page-methodology", "b5.nav.methodology"], ["/about/author", "footer-page-author", "b6.about"], ["/cases", "footer-cases-link", "b6.public_cases"]];
const EXPLORE = [["/catalogue", "footer-catalogue-link", "b5.nav.catalogue"], ["/demo", "footer-demo-link", "b5.nav.demo"], ["/help", "footer-help-link", "b5.nav.help"], ["/pricing", "footer-pricing-link", "nav.pricing"]];
const LEGAL = [["/about/privacy", "footer-page-privacy", "b6.privacy"], ["/about/terms", "footer-page-terms", "b6.terms"], ["/about/refund", "footer-page-refund", "b6.refund"]];

function Col({ title, items }) {
  const { t } = useTranslation();
  return (
    <div className="min-w-0">
      <p className={HEAD}>{t(title)}</p>
      <ul className="mt-3">{items.map(([to, id, k]) => <li key={id}><Link to={to} data-testid={id} className={L}>{t(k)}</Link></li>)}</ul>
    </div>
  );
}

function Operator() {
  const { t } = useTranslation();
  const [op, setOp] = useState(null);
  useEffect(() => { api.get("/settings/public").then((r) => setOp(r.data.operator)).catch(() => setOp(null)); }, []);
  if (!op) return null;
  return <p className="mt-1" data-testid="footer-operator">{t("b8.operator", { name: op.legal_name, address: op.address, reg: op.registration_no, jur: op.jurisdiction })}</p>;
}

export function PublicFooter() {
  const { t } = useTranslation();
  return (
    <footer className="mt-16 border-t border-sand-line bg-sand" data-testid="public-footer">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:grid-cols-2 sm:px-6 lg:grid-cols-12 lg:gap-8 lg:py-16">
        <div className="min-w-0 sm:col-span-2 lg:col-span-4">
          <p className="flex h-8 items-end font-display text-2xl font-semibold text-ink" data-testid="footer-name">Valeriia</p>
          <p className="mt-3 max-w-sm text-[15px] text-neutral-ink" data-testid="footer-description">{t("b6.description")}</p>
          <p className="mt-5 text-[15px]" data-testid="footer-contact"><span className="block text-xs font-semibold uppercase tracking-[0.16em] text-clay-strong">{t("b6.contact")}</span><span className="mt-1 block text-ink"><SupportEmail /></span></p>
        </div>
        <nav aria-label={t("b6.site")} data-testid="footer-nav" className="grid grid-cols-2 gap-6 sm:col-span-2 lg:col-span-5">
          <Col title="b7.learn" items={LEARN} />
          <Col title="b7.explore" items={EXPLORE} />
        </nav>
        <nav aria-label={t("b6.legal")} data-testid="footer-legal" className="sm:col-span-2 lg:col-span-3">
          <Col title="b6.legal" items={LEGAL} />
        </nav>
      </div>
      <div className="border-t border-sand-line">
        <div className="mx-auto flex max-w-6xl flex-col gap-4 px-4 py-8 sm:px-6 lg:flex-row lg:items-center lg:justify-between" data-testid="footer-apps">
          <div className="min-w-0"><p className="font-display text-lg font-semibold text-ink">{t("b7.apps")}</p><p className="mt-1 text-sm text-neutral-ink">{t("b7.apps_note")}</p></div>
          <AppBadges testid="footer-app-badges" />
        </div>
      </div>
      <div className="border-t border-sand-line">
        <div className="mx-auto max-w-6xl px-4 py-5 text-xs text-neutral-ink sm:px-6"><p data-testid="footer-copyright">{t("b6.copyright", { year: new Date().getFullYear() })}</p><Operator /></div>
      </div>
    </footer>
  );
}
